module.exports = __webpack_public_path__ + "static/media/setting.4dfe93e7.svg";